import React from "react";
import style from "../dashboard.module.scss";
import allAnnouncements from "../../../../../assets/dashboardImages/announcements.png";
import announcementItemAdmin from "../../../../../assets/dashboardImages/announcementItemAdmin.png";
import announcementItemSchool from "../../../../../assets/dashboardImages/announcementItemSchool.png";

export const AnnouncementsCard = () => {
  const announcements = [
    { text: "Anasayfamız yenilendi.", type: "admin" },
    { text: "TALENT-CUP Yarı Final 5-12 Mayıs tarihleri arasında!", type: "admin" },
    { text: "TALENT-CUP Final 13-20 Mayıs tarihleri arasında!", type: "admin" },
    { text: "ROBOT14 modülü yenilendi.", type: "admin" },
    { text: "CYBER14 çok yakında yayında!", type: "admin" },
    
  ];
  return (
    <div className={`${style.card} ${style.scrollableCard}`}>
      <h5 className={style.sectionTitle}>
        <img width="30px" src={allAnnouncements} alt="Duyurular İkonu" /> Duyurular
      </h5>
      <div className={style.scrollContent}>
        {announcements.map((announcement, index) => {
          return (
            <div key={index} className={`${style.taskBox}`}>
              <span className={`fs-3 me-2 p-1 pe-0`}>
                {announcement.type === "admin" && <img width="30px" src={announcementItemAdmin} alt="Duyurular İkonu" />}
                {announcement.type === "institution" && <img width="30px" src={announcementItemSchool} alt="Duyurular İkonu" />}
              </span>
              <p className="mb-0 fw-bold text-light">{announcement.text}</p>
            </div>
          );
        })}
      </div>
    </div>
  );
};
